/*
  Promos from Mobius (see snippets/mobius-promos-loader.liquid): fills the welcome-offer widget,
  the promo banner and the announcement bar with what Mobius says is live. The sign-up pop-up is
  handled by signup-popup.js, which this tells about each later answer ("lf:promos-change").

  A spot Mobius has nothing for keeps the theme's own settings, except the promo banner, which
  stays hidden so an old campaign code never shows. At the next scheduled change the answer is
  fetched again, so a page left open hands over from one promo to the next on time.
*/
(function () {
  'use strict';

  var promos = window.lfPromos;
  if (!promos) return;

  function each(root, selector, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }

  // Swaps keep the theme's original, so a spot can go back to it when its promo ends.
  function setHtml(el, html) {
    if (!('lfOriginalHtml' in el)) el.lfOriginalHtml = el.innerHTML;
    el.innerHTML = html === null ? el.lfOriginalHtml : html;
  }

  function setAttr(el, name, value) {
    var store = el.lfOriginalAttrs || (el.lfOriginalAttrs = {});
    if (!(name in store)) store[name] = el.getAttribute(name);
    var next = value === null ? store[name] : value;
    if (next === null) el.removeAttribute(name);
    else el.setAttribute(name, next);
  }

  function setStyle(el, prop, value) {
    var store = el.lfOriginalStyles || (el.lfOriginalStyles = {});
    if (!(prop in store)) store[prop] = el.style[prop];
    el.style[prop] = value || store[prop];
  }

  // A promo whose end has passed counts as nothing live, even before the next answer arrives.
  function stillLive(item) {
    return item && !(item.ends_at && Date.parse(item.ends_at) <= Date.now()) ? item : null;
  }

  // hide: a past customer with no welcome-back offer sees no welcome offer at all.
  function welcomeOffer(offer, hide) {
    each(document, '[data-mobius-spot="welcome_offer"]', function (root) {
      setStyle(root, 'display', hide ? 'none' : '');
      var code = offer ? offer.code : null;
      each(root, '[data-mobius-message]', function (el) {
        setHtml(el, offer ? promos.format(offer.message, code) : null);
      });
      each(root, '[data-mobius-code]', function (el) {
        setHtml(el, offer ? promos.escape(code || '') : null);
      });
      if (root.hasAttribute('data-discount-code')) setAttr(root, 'data-discount-code', code);
      each(root, '[data-discount-code]', function (el) { setAttr(el, 'data-discount-code', code); });
      root.removeAttribute('data-mobius-pending');
    });
  }

  function promoBanner(banner) {
    each(document, '[data-mobius-spot="promo_banner"]', function (root) {
      var button = root.querySelector('[data-promo-code-banner-button]');
      if (banner && button) {
        setAttr(button, 'data-promo-code', banner.code);
        setStyle(button, 'backgroundColor', banner.colours && banner.colours.bg);
        setStyle(button, 'borderColor', banner.colours && banner.colours.border);
        setStyle(button, 'color', banner.colours && banner.colours.text);
        // Both copies: the invisible one keeps the button's width when "Code copied" swaps in.
        each(button, '[data-promo-code-banner-original], [data-promo-code-banner-text]', function (el) {
          setHtml(el, promos.format(banner.message, banner.code));
        });
      }
      // Inline style, not the hidden attribute: the wrapper's inline-flex class would beat [hidden].
      root.style.display = banner && button ? '' : 'none';
      root.removeAttribute('data-mobius-hold');
    });
  }

  function announcement(message) {
    each(document, '[data-mobius-spot="announcement"]', function (root) {
      var html = null;
      if (message) {
        // Same markup the section renders for its own text, with and without a link.
        var text = '<p>' + promos.format(message.message) + '</p>';
        // A link that isn't a site path or https:// address is dropped: the message shows without it.
        var link = promos.safeUrl(message.link);
        html = link
          ? '<a class="announcement-bar__link inline-block" href="' + promos.escape(link) + '"><div class="rte p-0">' + text + '</div></a>'
          : '<div class="rte py-1">' + text + '</div>';
      }
      setHtml(root, html);
      var bar = root.closest('.announcement-bar');
      if (bar) {
        setStyle(bar, 'background', message && message.colours && message.colours.bg);
        setStyle(bar, 'color', message && message.colours && message.colours.text);
      }
      root.removeAttribute('data-mobius-pending');
    });
  }

  var refreshTimer = null;

  function apply(data) {
    var first = !promos.applied;
    promos.applied = true;
    promos.latest = data;
    welcomeOffer(stillLive(data && data.welcome_offer), !!(data && data.hide_welcome_offer));
    promoBanner(stillLive(data && data.promo_banner));
    announcement(stillLive(data && data.announcement));
    // The sign-up pop-up (signup-popup.js) reads the first answer itself; tell it about later ones.
    if (!first) document.dispatchEvent(new CustomEvent('lf:promos-change', { detail: data }));

    clearTimeout(refreshTimer);
    var wait = data && data.next_change_at ? Date.parse(data.next_change_at) - Date.now() + 1000 : NaN;
    if (wait > 0 && wait < 2147483647) {
      refreshTimer = setTimeout(function () {
        // If Mobius doesn't answer, the old answer still drops whatever has ended.
        promos.refresh().then(function (fresh) { apply(fresh || data); });
      }, wait);
    }
  }

  promos.ready.then(function (data) {
    // The loader's last-resort timer already showed the fallbacks: don't swap under the visitor.
    if (promos.settled) return promos.settle();
    apply(data);
  });
})();
